import axios from "axios";

// Custom Domain: API-Calls an Produktions-Domain senden
// (Kubernetes Ingress routet /api nur für die Haupt-Domain zum Backend)
// Custom Domain: API-Calls an Produktions-Domain (aus Build-Env), sonst gleiche Origin
const isCustomDomain = window.location.hostname.endsWith('absetzbecken-gebraucht.de');
const BACKEND_URL = isCustomDomain
  ? (process.env.REACT_APP_BACKEND_URL || window.location.origin)
  : window.location.origin;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ 
  baseURL: API_BASE,
  timeout: 30000, // 30 Sekunden Timeout
  withCredentials: true, // httpOnly Auth-Cookie mitsenden
});

// Retry-Konfiguration
const MAX_RETRIES = 3;
const RETRY_DELAY = 1000; // 1 Sekunde

// Helper: Verzögerung
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Helper: Prüfen ob Fehler wiederholbar ist (Netzwerkfehler)
const isRetryableError = (error) => {
  // Netzwerkfehler (kein Response)
  if (!error.response) return true;
  // Server-Fehler (5xx) - außer 501
  if (error.response.status >= 500 && error.response.status !== 501) return true;
  // Timeout
  if (error.code === 'ECONNABORTED') return true;
  return false;
};

// Request Interceptor
api.interceptors.request.use((config) => {
  // Auth läuft ausschließlich über das httpOnly-Cookie (kein Token im localStorage)
  // Prevent caching of API requests
  config.headers = config.headers || {};
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  config.headers['Expires'] = '0';
  
  // Retry-Counter initialisieren
  config._retryCount = config._retryCount || 0;
  
  return config;
});

// Response Interceptor mit Retry-Logik
api.interceptors.response.use(
  (response) => {
    // Sliding Session: Cookie wird serverseitig erneuert, Header nur informativ
    return response;
  },
  async (error) => {
    const config = error.config;
    
    // Sitzung abgelaufen/ungültig:
    // - 401 (Unauthorized): Token ungültig oder abgelaufen
    // - 403 mit "Not authenticated": Request ohne Token (Token wurde entfernt)
    const isSessionExpired =
      error.response?.status === 401 ||
      (error.response?.status === 403 && error.response?.data?.detail === "Not authenticated");
    
    if (isSessionExpired) {
      // Auf Custom-Domain oder beim initialen Session-Check: kein Redirect zum Login
      if (!isCustomDomain && !config?._skipAuthRedirect) {
        localStorage.removeItem("bc_logged_in");
        localStorage.removeItem("bc_user");
        // Nur weiterleiten wenn nicht schon auf Login-Seite
        if (!window.location.pathname.includes('/login')) {
          sessionStorage.setItem("bc_session_expired", "1");
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
    
    // Retry-Logik für Netzwerkfehler
    if (isRetryableError(error) && config._retryCount < MAX_RETRIES) {
      config._retryCount += 1;
      console.log(`🔄 Netzwerkfehler - Wiederholungsversuch ${config._retryCount}/${MAX_RETRIES}...`);
      
      // Exponentielles Backoff
      await delay(RETRY_DELAY * config._retryCount);
      
      return api(config);
    }
    
    return Promise.reject(error);
  }
);

export const SettingsAPI = {
  get: () => api.get("/settings").then(r => r.data),
  patch: (payload) => api.patch("/settings", payload).then(r => r.data),
  nextSerial: () => api.get("/settings/next_serial").then(r => r.data),
  consume: (used_number) => api.post("/settings/consume_next", { used_number }).then(r => r.data),
};

export default api;
